import { render, staticRenderFns } from "./AttachmentCard.vue?vue&type=template&id=33bb972e&scoped=true"
import script from "./AttachmentCard.vue?vue&type=script&lang=js"
export * from "./AttachmentCard.vue?vue&type=script&lang=js"
import style0 from "./AttachmentCard.vue?vue&type=style&index=0&id=33bb972e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb972e",
  null
  
)

export default component.exports